import type { IdentityUser } from '../providers';
import type { CombinedUserClaims } from './auth0IdToken';

/**
 * Returns the PetSmart customer (Janrain) uuid from the session user.
 * Auth0 id tokens expose this as `petsmart.com/uuid`; legacy Velocity access
 * tokens store the same value in `sid`.
 */
export function getCustomerUuid(user: IdentityUser | CombinedUserClaims | undefined): string | undefined {
    return (user as CombinedUserClaims)?.['petsmart.com/uuid'] || user?.sid || undefined;
}
